export enum DocumentSubState {
    Quote,
    Referal,
    Bind,
    Custom
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/documentSubState.enum.ts